module.exports = __webpack_public_path__ + "img/default.2c0d95dc.png";